import React from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
const CareerCard = ({ icon, title, details, detailData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleDetailsClick = () => {
    navigate("/career-details", {
      state: detailData,
    });
  };

  return (
    <div className="col-md-3 col-sm-6 mb-4">
      <div className="service-card text-center h-100">
        <div className="service-icon mb-3">
          {icon}
        </div>
        <h4 className="service-title">{title}</h4>
        <ul className="service-list text-start">
          {details.map((point, index) => (
            <li key={index}>{point}</li>
          ))}
        </ul>
        <div className="mt-auto">
          <button className="btn btn-primary blue-color-code" onClick={handleDetailsClick}>
            {t("more_details_button")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CareerCard;
